import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import WhyAlignexa from "../components/landing/WhyAlignexa";
import HowItWorks from "../components/landing/HowItWorks";
import PlatformOverview from "../components/landing/PlatformOverview";
import WhoWeServe from "../components/landing/WhoWeServe";
import FeatureHighlights from "../components/landing/FeatureHighlights";
import ProductPreview from "../components/landing/ProductPreview";
import FinalCTA from "../components/landing/FinalCTA";
import Footer from "../components/landing/Footer";

export default function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-white text-[#0F172A] font-body antialiased overflow-x-hidden"
    >
      <Navbar />
      <main>
        <Hero />
        <WhyAlignexa />
        <HowItWorks />
        <PlatformOverview />
        <WhoWeServe />
        <FeatureHighlights />
        <ProductPreview />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
